import { render, staticRenderFns } from "./ExpansionPanel.vue?vue&type=template&id=4257aafc"
import script from "./ExpansionPanel.vue?vue&type=script&lang=js"
export * from "./ExpansionPanel.vue?vue&type=script&lang=js"
import style0 from "./ExpansionPanel.vue?vue&type=style&index=0&id=4257aafc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProfileTablePanel: require('/home/vsts/work/1/s/components/profile/TablePanel.vue').default,ProfileTabPanel: require('/home/vsts/work/1/s/components/profile/TabPanel.vue').default})
